export const SEP_LIMIT_MAX_CHARACTERS = 240;

export const SEP_LIMIT_ERROR_MESSAGE = `The sep name is too long. Please shorten it to ${SEP_LIMIT_MAX_CHARACTERS} characters or less.`;

export const SEP_LIMIT_ALERT_DURATION = 7000; // in milliseconds

export const URL_NAME = 'https://sep.constellation.com/';

export const TRM_DATAFIELDS_ERROR_MESSAGE = 'This field is populated from APM data and cannot be edited.';


